export default "<i class=\"fas fa-comments\" (click)=\"propagateClick  == 'true' && !disabled && goToForum()\" [ngClass]=\"{'disabled': disabled}\"></i>\r\n"